module.exports = __webpack_public_path__ + "img/BIAnalysis.9c8f881b.png";